/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ServiceDrivenFieldViewer} from "./ServiceDrivenFieldViewer";
import {service as PermitService} from "../../../Services/PermitService";
import autobind from "autobind-decorator";
import React from "react";
import {service as SpeciesListService} from "../../../Services/SpeciesListService";
import {StreamBankLink} from "../../../Components/Common/StreamBankLink";

const _PermitFieldViewer = ServiceDrivenFieldViewer(PermitService);

export const PermitFieldViewer = (props) => {
	const {Value, Data} = props;

	const permitId = Value ?? Data?.Permit?.permitId;

	if (!permitId) {
		return 'N/A';
	}

	return <div className="sb-autocomplete-item">
		<a className="link-primary"
		   onClick={() => props.CustomData.showPermit(permitId)}>
			<_PermitFieldViewer
				{...props}
				Value={permitId}
			/>
		</a>
	</div>
}